import styled, { css } from 'styled-components/macro';
import { ModelListDiv } from '../../../../components/ModelListStyles';
import { defaultSpacing } from '../../../../styles/utils';

export const CustomShowModelListDiv = styled(ModelListDiv)`
  border: ${props => props.theme.defaultBorder};
  ${props =>
    !props.hideBorderTop &&
    css`
      border-top: 2px solid black;
    `}
  position: relative;
  padding: 5rem 0;
  @media screen and (min-width: 768px) {
    padding: 7rem 0;
  }
  @media screen and (min-width: 1440px) {
    padding: 8rem 0;
  }
  > h5 {
    ${defaultSpacing};
    font-size: 1.5rem;
  }
`;

export const PromoSpan = styled.span`
  color: ${props => props.theme.dustyGray};
  text-decoration: line-through;
  margin-right: 5px;
`;

export const DetailedShowInfoDiv = styled.div`
  background-color: ${props => props.theme.concrete};
  padding: 2rem;
  margin-top: 25px;
  margin-bottom: 30px;
  @media screen and (min-width: 768px) {
    padding: 3rem;
    margin-bottom: 37px;
  }
  @media screen and (min-width: 1024px) {
    padding: 4rem;
    margin-bottom: 45px;
  }

  ${defaultSpacing}
`;

export const InfoItemDiv = styled.div`
  margin-bottom: 10px;
  @media screen and (min-width: 768px) {
    display: flex;
    align-items: center;
    h5 {
      font-weight: 500;
      width: 150px;
      line-height: 0;
      text-transform: capitalize;
    }
  }
`;

export const SummaryTableMessageDiv = styled.div`
  display: flex;
  justify-content: center;
`;

export const SummaryTableMessageP = styled.p`
  text-align: center;
  font-style: italic;
  width: 218px;
  color: ${props => props.theme.dustyGray};
`;
